import { render, staticRenderFns } from "./PointsAdjustment.vue?vue&type=template&id=02e197a2&scoped=true"
import script from "./PointsAdjustment.vue?vue&type=script&lang=js"
export * from "./PointsAdjustment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e197a2",
  null
  
)

export default component.exports